import React from "react";
import { useCptFilterLoading } from "../../common/useCptFilterLoading";
import {
  MONTH_OPTIONS,
  YEAR_OPTIONS,
  PERFORMANCE_TYPE_OPTIONS,
  formatMonthLabel
} from "./monthlyPerformanceUtils";

const MonthlyPerformanceFilter = ({ filters, onChange, onApply, loading = false }) => {
  const { isFilterBusy, beginSubmit } = useCptFilterLoading(loading);

  const handleApply = () => {
    beginSubmit();
    onApply();
  };
  const baseMonthLabel = formatMonthLabel(filters.baseYear, filters.baseMonth);
  const comparedMonthLabel = formatMonthLabel(filters.comparedYear, filters.comparedMonth);

  const onInputChange = (field) => (event) => {
    onChange({ ...filters, [field]: event.target.value });
  };

  return (
    <div className={`mpr-filter-card ${isFilterBusy ? "mpr-filter-card--loading" : ""}`}>
      <div className="mpr-filter-header">
        <div>
          <h4>Monthly Performance Report</h4>
          <p>Select base month and compared month, then apply to load analytics and patient list.</p>
        </div>
      </div>
      <div className="mpr-filter-grid">
        <div className="mpr-filter-field">
          <label>{`Base: ${baseMonthLabel}`}</label>
          <div className="mpr-select-row">
            <select value={filters.baseMonth} onChange={onInputChange("baseMonth")} className="mpr-select" disabled={isFilterBusy}>
              {MONTH_OPTIONS.map((opt) => (
                <option key={`bm-${opt.value}`} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
            <select value={filters.baseYear} onChange={onInputChange("baseYear")} className="mpr-select" disabled={isFilterBusy}>
              {YEAR_OPTIONS.map((year) => (
                <option key={`by-${year}`} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="mpr-filter-field">
          <label>{`Compared: ${comparedMonthLabel}`}</label>
          <div className="mpr-select-row">
            <select value={filters.comparedMonth} onChange={onInputChange("comparedMonth")} className="mpr-select" disabled={isFilterBusy}>
              {MONTH_OPTIONS.map((opt) => (
                <option key={`cm-${opt.value}`} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
            <select value={filters.comparedYear} onChange={onInputChange("comparedYear")} className="mpr-select" disabled={isFilterBusy}>
              {YEAR_OPTIONS.map((year) => (
                <option key={`cy-${year}`} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="mpr-filter-field">
          <label>Performance Type</label>
          <select value={filters.performanceType} onChange={onInputChange("performanceType")} className="mpr-select" disabled={isFilterBusy}>
            {PERFORMANCE_TYPE_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>

        <div className="mpr-filter-actions">
          <button
            type="button"
            className={`mpr-apply-btn ${isFilterBusy ? "mpr-apply-btn--loading" : ""}`}
            onClick={handleApply}
            aria-busy={isFilterBusy}
          >
            {isFilterBusy ? <i className="mdi mdi-loading mdi-spin" /> : <i className="mdi mdi-filter" />}
            {isFilterBusy ? "Loading..." : "Filter"}
          </button>
        </div>
      </div>
      <div className="mpr-filter-caption">
        <span>Base: {baseMonthLabel}</span>
        <span>Compared: {comparedMonthLabel}</span>
      </div>
    </div>
  );
};

export default MonthlyPerformanceFilter;
